var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewNavbar',{attrs:{"variant":"signup"}}),_vm._v(" "),_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }